enum ENV_MAP {
  production = 'prd',
  staging = 'stg',
  development = 'dev',
}

export const getEnvValue = () => {
  return (
    ENV_MAP[import.meta.env.VITE_NODE_ENV as keyof typeof ENV_MAP] ??
    ENV_MAP.development
  );
};
